import {
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';

import {
  GeneralTableBox,
  HeadTableCell,
  NoDataSkeleton,
  RowTableCell,
  TableBodySkeleton,
} from '../../../common/components';
import { formatCurrency } from '../../../utils/formatUtils';

const AccountingLedgerTable = ({ rows, isLoading }) => (
  <GeneralTableBox>
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <HeadTableCell>Cuenta contable</HeadTableCell>
          <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Debe</HeadTableCell>
          <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Haber</HeadTableCell>
          <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Saldo</HeadTableCell>
          <HeadTableCell>Tipo saldo</HeadTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? <TableBodySkeleton /> : rows.length ? rows.map((row) => (
          <TableRow key={row.account_label} hover>
            <RowTableCell>{row.account_label}</RowTableCell>
            <RowTableCell align="right" sx={{ textAlign: 'right' }}>{formatCurrency(row.debit, 2)}</RowTableCell>
            <RowTableCell align="right" sx={{ textAlign: 'right' }}>{formatCurrency(row.credit, 2)}</RowTableCell>
            <RowTableCell align="right" sx={{ textAlign: 'right' }}>{formatCurrency(Math.abs(row.balance), 2)}</RowTableCell>
            <RowTableCell>{row.balance >= 0 ? 'Deudor' : 'Acreedor'}</RowTableCell>
          </TableRow>
        )) : (
          <NoDataSkeleton colSpan={5} message="No hay asientos contabilizados para el mayor." />
        )}
      </TableBody>
    </Table>
  </GeneralTableBox>
);

export default AccountingLedgerTable;
